import { Component } from '@angular/core';

@Component({
  selector: 'app-top-header',
  imports: [],
  templateUrl: './top-header.html',
  styleUrl: './top-header.scss',
})
export class TopHeader {

}
